import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { cssGenerator } from '@/mixins/css-generator';
import tooltip from '@/mixins/components/tooltip';
import { SQUASH_DROPLET } from '@/constants';
import DropletOptions from '../_bubble-options';
import TextSwapperOptions from './components/_edit-options';
import schema from './droplet.schema';
const dropletSchema = schema();

export default Vue.component('text-swapper', {
  template: require('./template.html'),
  name: 'text-swapper',
  mixins: [cssGenerator],
  computed: {
    ...mapGetters([
      'currentPage',
      'viewport',
      'localStyle',
      'activeDroplet',
      'activeState',
      'animationPreview',
      'dropletObserver',
      'bouncePluginHook',
      'dragging',
      'globalBubbleOptionsOpen',
    ]),
    roamingTemplate() {
      return this.currentPage.type !== 'template' && this.droplet.templateRegion;
    },
    isActiveDroplet() {
      return this.activeDroplet._id === this.droplet._id;
    },
    hideTransform() {
      return this.dragging || this.globalBubbleOptionsOpen;
    },
    profile() {
      return this._dropletType(this.droplet);
    },
    displayStatus() {
      let settings = {
        desktop: 'default',
        tablet: 'default',
        mobile: 'default',
      };
      const selector = _.find(this.droplet.mediaQueries, { selector: ', .drzText-swapper' });
      if (selector) {
        const property = _.find(selector.properties, { property: 'display' });
        if (property) {
          settings = property;
        }
      }
      return settings;
    },
  },
  data() {
    return {
      type: dropletSchema.type,
      SQUASH_DROPLET,
      display: {
        top: null,
        left: null,
        right: null,
        bottom: null,
        ctPaddingTop: null,
        ctPaddingBottom: null,
        ctPaddingLeft: null,
        ctPaddingRight: null,
        transform: null,
        perspective: null,
        height: null,
        width: null,
        'padding-left': null,
        'padding-right': null,
        'padding-top': null,
        'padding-bottom': null,
        'border-top-left-radius': null,
        'border-top-right-radius': null,
        'border-bottom-left-radius': null,
        'border-bottom-right-radius': null,
        'border-left-width': null,
        'border-right-width': null,
        'border-top-width': null,
        'border-bottom-width': null,
      },
      hidden: false,
      dropletHovered: false,
      setBubbleSize: 'dropletBubble-normal',
      showEditBubble: false,
      showRevealClass: false,
    };
  },
  props: ['droplet', 'items', 'index'],
  components: {
    DropletOptions,
    TextSwapperOptions,
    tooltip,
  },
  watch: {
    isActiveDroplet(is) {
      if (is) {
        this._scrollToDroplet(this.$el);
      }
    },
    'activeDroplet._id': function c(id) {
      if (!id) {
        this.showRevealClass = false;
      }
    },
    activeState(state) {
      if (state === ':reveal' && this.isActiveDroplet) {
        this.showRevealClass = true;
      } else {
        this.showRevealClass = false;
      }
    },
    animationPreview(should) {
      if (should && this.isActiveDroplet) {
        const droplet = this.$refs.dropletRow;
        const $droplet = $(droplet);
        $droplet.drzOnReveal({
          editing: this.isActiveDroplet,
          child: '.drzText-swapper',
        });
      }
    },
    viewport() {
      this.callCssGenerator();
      this.observeVisibility();
    },
    'localStyle.value': function setLocals() {
      this.setDisplay();
    },
    dropletObserver(id) {
      if (this.droplet._id === id) {
        this.observeVisibility();
        this.$store.dispatch('setDropletObserver', false);
      }
    },
    bouncePluginHook(id) {
      if (this.droplet._id === id) {
        setTimeout(() => {
          this.bouncePlugin();
          this.$store.dispatch('callPluginBounce', false);
        }, 250);
      }
    },
  },
  mounted() {
    this.callCssGenerator();
    this.observeVisibility();
    $(document).ready(() => {
      setTimeout(this.bindPlugin, 500);
    });
  },
  beforeDestroy() {
    this.destroyPlugin();
  },
  methods: {
    callCssGenerator() {
      return this.generateCSS({
        drp: this.droplet,
      });
    },
    observeVisibility() {
      const display = this.displayStatus;
      if (display[this.viewport] === 'none' || (display[this.viewport] === 'default' && display.desktop === 'none')) {
        this.hidden = true;
      } else {
        this.hidden = false;
      }
    },
    bindPlugin() {
      const $droplet = $(this.$refs.textSwapper);
      $droplet.drzTextSwapper();
    },
    destroyPlugin() {
      const $droplet = $(this.$refs.textSwapper);
      if ($droplet.drzTextSwapper.destroy) {
        $droplet.drzTextSwapper.destroy($droplet);
      }
    },
    bouncePlugin() {
      const $droplet = $(this.$refs.textSwapper);
      if ($droplet.drzTextSwapper.destroy) {
        $droplet.drzTextSwapper.destroy($droplet, this.bindPlugin);
      }
    },
    setDisplay() {
      if (this.activeDroplet._id === this.droplet._id) {
        const styles = this.localStyle;
        if (styles.properties.length > 0) {
          _.forEach(styles.properties, (property) => {
            this.$set(this.display, property, styles.value);
          });
        } else {
          _.forOwn(this.display, (value, key) => {
            this.display[key] = null;
          });
        }
      }
    },
    toggleBubble() {
      if (!this.roamingTemplate) {
        this.showEditBubble = !this.showEditBubble;
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/text-swapper/index.js